/** 表单验证规则与正则 */

/** 验证结果 */
export interface ValidateResult {
  valid: boolean;
  message: string;
}

/* ---------- 正则 ---------- */

/** 中文姓名（2-20个汉字） */
const NAME_RE = /^[\u4e00-\u9fa5]{2,20}$/;

/** 手机号（11位数字，1开头） */
const PHONE_RE = /^1[3-9]\d{9}$/;

/** 身份证号（18位，支持末位X） */
const IDCARD_RE = /^\d{17}[\dXx]$/;

/** 身份证校验码（GB 11643-1999） */
function idCardChecksum(code: string): boolean {
  const weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
  const map = ["1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"];
  let sum = 0;
  for (let i = 0; i < 17; i++) {
    sum += Number(code[i]) * weights[i];
  }
  const last = code[17];
  if (last == null) return false;
  return map[sum % 11] === last.toUpperCase();
}

/** 驾照证号（18位或15位） */
const LICENSE_NO_RE = /^\d{15}(\d{2}[\dXx])?$/;

/** 驾照类型（C1/C2/B1/B2/A1/A2 等） */
const LICENSE_TYPE_RE = /^[A-Z][1-9]$/;

/** 日期格式 YYYY-MM-DD */
const DATE_RE = /^\d{4}-\d{2}-\d{2}$/;

/** 邮箱 */
export const EMAIL_RE = /^[\w.+-]+@[\w-]+(\.[\w-]+)+$/;

/* ---------- 导出验证函数 ---------- */

/** 验证姓名 */
export function validateName(name: string): ValidateResult {
  if (!name.trim()) return { valid: false, message: "姓名不能为空" };
  if (!NAME_RE.test(name.trim()))
    return { valid: false, message: "请输入正确的中文姓名（2-20个汉字）" };
  return { valid: true, message: "" };
}

/** 验证手机号 */
export function validatePhone(phone: string): ValidateResult {
  if (!phone.trim()) return { valid: false, message: "手机号不能为空" };
  if (!PHONE_RE.test(phone.trim()))
    return { valid: false, message: "请输入正确的11位手机号码" };
  return { valid: true, message: "" };
}

/** 验证身份证号 */
export function validateIdCard(idCard: string): ValidateResult {
  if (!idCard.trim()) return { valid: false, message: "身份证号码不能为空" };
  const v = idCard.trim().replace(/\s/g, "");
  if (!IDCARD_RE.test(v))
    return { valid: false, message: "身份证号码格式不正确（需18位）" };
  if (!idCardChecksum(v))
    return { valid: false, message: "身份证号码校验失败，请检查后重试" };
  return { valid: true, message: "" };
}

/** 验证驾照证号 */
export function validateLicenseNo(no: string): ValidateResult {
  if (!no.trim()) return { valid: false, message: "驾照证号不能为空" };
  if (!LICENSE_NO_RE.test(no.trim()))
    return { valid: false, message: "驾照证号格式不正确" };
  return { valid: true, message: "" };
}

/** 验证驾照类型 */
export function validateLicenseType(type: string): ValidateResult {
  if (!type.trim()) return { valid: false, message: "驾照类型不能为空" };
  if (!LICENSE_TYPE_RE.test(type.trim().toUpperCase()))
    return { valid: false, message: "驾照类型格式不正确（如 C1、B2）" };
  return { valid: true, message: "" };
}

/** 验证有效期至 */
export function validateLicenseExpiry(date: string): ValidateResult {
  if (!date.trim()) return { valid: false, message: "有效期不能为空" };
  if (!DATE_RE.test(date.trim()))
    return { valid: false, message: "日期格式不正确（如 2030-01-01）" };
  if (new Date(date) <= new Date())
    return { valid: false, message: "驾照已过期或即将过期" };
  return { valid: true, message: "" };
}

/** 验证邮箱 */
export function validateEmail(email: string): ValidateResult {
  if (!email.trim()) return { valid: false, message: "邮箱地址不能为空" };
  if (!EMAIL_RE.test(email.trim()))
    return { valid: false, message: "请输入正确的邮箱地址" };
  return { valid: true, message: "" };
}
